module.exports = __webpack_public_path__ + "static/contribution_img6@2x-9e2219a4e327cca91534c28caedee83b.jpg";